export default "__VITE_ASSET__EHVbOW6j__"